import React from 'react';
import { RecorderStatus } from '../../../../../../../types/rest/mockServiceTypes';
import { Button } from 'react-bootstrap';
import BzmIcon from '../../../../../../../components/icons/BzmIcon';
import styles from './RecordingButton.module.css';
import clsx from 'clsx';

interface Props {
  status: RecorderStatus;
  onClick: () => void;
  disabled: boolean;
}
const RecordingButton = ({ status, onClick, disabled }: Props) => {
  const isRecording = status === 'RUNNING';
  const label = isRecording ? 'Stop Recording' : 'Start Recording';
  return (
    <Button disabled={disabled} onClick={onClick} variant={!isRecording ? 'danger' : 'outline-danger'}>
      <BzmIcon variant={'icon-bzm-record'} className={clsx('mr-3', isRecording && styles.recording)} />
      {label}
    </Button>
  );
};

export default RecordingButton;
